/**
 * Session operations — list active sessions.
 */

import type { ArbiClient, components } from '@arbidocs/client'
import { requireData } from '../errors.js'

type SessionInfoResponse = components['schemas']['SessionInfoResponse']

/**
 * List all active sessions for the current user.
 * Agents see only their own session.
 */
export async function listSessions(arbi: ArbiClient): Promise<SessionInfoResponse[]> {
  return requireData(await arbi.fetch.GET('/v1/user/sessions'), 'Failed to fetch sessions')
}
